export const calculateGSTComponents = (baseAmount) => {
  const GST_RATE = 1.18;
  const totalAmount = parseFloat((baseAmount * GST_RATE).toFixed(2));

  return {
    totalAmount, // Base amount with GST applied
  };
};
